import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import Promise from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/blog.constant";

export {
    addMultipleFeaturedImages,
    addSingleFeaturedImage,
    updateSingleFeaturedImage,
    getSingleFeaturedImage,
    searchFeaturedImages,
    searchFeaturedImagesWithSearchCriteria,
    prepareFeaturedImagesList
}

const collectionName = 'featured-images';
const collectionReference = collection(fireStoreDB, collectionName);

const addMultipleFeaturedImages = (featuredImages) => {
    return Promise.map(featuredImages, async featuredImage => {
        await addSingleFeaturedImage(featuredImage);
    });
}

const addSingleFeaturedImage = (featuredImage) => {
    featuredImage.createdAt = new Date();
    featuredImage.updatedAt = featuredImage.createdAt;
    return addDoc(collectionReference, featuredImage);
}

const updateSingleFeaturedImage = (featuredImage) => {
    const documentReference = doc(fireStoreDB, collectionName, featuredImage.id);
    featuredImage.updatedAt = new Date();
    return setDoc(documentReference, featuredImage);
}

const getSingleFeaturedImage = (featuredImageId) => {
    const documentReference = doc(fireStoreDB, collectionName, featuredImageId);
    return getDoc(documentReference);
}

const searchFeaturedImages = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const featuredImageResult = await getDocs(searchQuery);
    return prepareFeaturedImagesList(featuredImageResult);
}

const searchFeaturedImagesWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchFeaturedImagesWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const featuredImageResult = await getDocs(searchQuery);
    return prepareFeaturedImagesList(featuredImageResult);
}

const prepareFeaturedImagesList = (featuredImageResult) => {
    const featuredImagesList = [];

    _.forEach(featuredImageResult.docs, featuredImageDoc => {
        featuredImagesList.push({
            ...featuredImageDoc.data(),
            id: featuredImageDoc.id
        });
    });

    return featuredImagesList;
}
